export default __webpack_public_path__ + "static/media/chevron-up.00adfda7.svg";